import api from './api';

export interface ChangeHistory {
  _id: string;
  workspaceId: string;
  entityType: string;
  entityId: string;
  changeType: 'CREATE' | 'UPDATE' | 'DELETE';
  fieldName: string;
  oldValue: any;
  newValue: any;
  changedBy: string;
  changedByName: string;
  changedAt: string;
  changeReason?: string;
  ipAddress?: string;
  userAgent?: string;
  createdAt: string;
  updatedAt: string;
}

export interface ChangeHistoryResponse {
  history: ChangeHistory[];
  count: number;
  total: number;
  hasMore: boolean;
}

export const changeHistoryService = {
  /**
   * Get change history for a specific entity
   */
  getHistory: async (
    workspaceId: string,
    entityType: string,
    entityId: string,
    options?: {
      limit?: number;
      offset?: number;
      fieldName?: string;
    }
  ): Promise<ChangeHistory[]> => {
    const params = {
      limit: options?.limit || 50,
      offset: options?.offset || 0,
      ...(options?.fieldName && { fieldName: options.fieldName }),
    };

    const response = await api.get<ChangeHistoryResponse>(
      `/workspaces/${workspaceId}/change-history/${entityType}/${entityId}`,
      { params }
    );

    return response.data.history;
  },

  /**
   * Get change history for a specific user
   */
  getUserHistory: async (
    workspaceId: string,
    userId: string,
    options?: {
      limit?: number;
      offset?: number;
      entityType?: string;
    }
  ): Promise<ChangeHistory[]> => {
    const params = {
      limit: options?.limit || 50,
      offset: options?.offset || 0,
      ...(options?.entityType && { entityType: options.entityType }),
    };

    const response = await api.get<ChangeHistoryResponse>(
      `/workspaces/${workspaceId}/change-history/user/${userId}`,
      { params }
    );

    return response.data.history;
  },

  /**
   * Get recent change history across the workspace
   */
  getRecentHistory: async (
    workspaceId: string,
    options?: {
      limit?: number;
      offset?: number;
      entityType?: string;
      changeType?: 'CREATE' | 'UPDATE' | 'DELETE';
    }
  ): Promise<ChangeHistory[]> => {
    const params = {
      limit: options?.limit || 50,
      offset: options?.offset || 0,
      ...(options?.entityType && { entityType: options.entityType }),
      ...(options?.changeType && { changeType: options.changeType }),
    };

    const response = await api.get<ChangeHistoryResponse>(
      `/workspaces/${workspaceId}/change-history/recent`,
      { params }
    );

    return response.data.history;
  },
};
